import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Iconify from 'src/components/Iconify';
import { useEffect, useState } from 'react';
import PipileneStageItem from './PipelineStageItem';
import v2_actionEditarPipeline from 'src/actions/v2/crm/v2_actionEditarPipeline';
import PopoverCriarEstagio from './PopoverCriarEstagio';
import v2_actionDeletarPipelineStage from 'src/actions/v2/crm/v2_actionDeletarPipelineStage';
import { FUNIL_DESIGN as D } from './FunilComponent.design';

export default function PipileneItem({
  index,
  pipelines,
  item,
  onCallback,
  user,
  cliente,
  onEdit,
  onDelete,
  ...other
}) {
  const [pipelineId, setPipelineId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const [isEdit, setIsEdit] = useState(null);
  const [estagios, setEstagios] = useState(item?.estagios);

  async function handleEditarPipilene(orders) {
    try {
      await v2_actionEditarPipeline(item.pipeline_id, {
        action: 'edit_order_pipeline_stage',
        scope: { orderIds: orders },
      }, cliente._id);
      await onCallback();
    } catch (error) {
      console.error('Erro ao editar pipeline:', error);
    }
  }

  async function handleDeletePipelineStage(stageId) {
    try {
      setIsLoading(true);
      await v2_actionDeletarPipelineStage(stageId);
      onCallback();
    } catch (error) {
      console.error('Erro ao deletar estágio:', error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    setEstagios(item?.estagios);
  }, [item]);

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedEstagios = Array.from(estagios);
    const [movedItem] = reorderedEstagios.splice(result.source.index, 1);
    reorderedEstagios.splice(result.destination.index, 0, movedItem);

    setEstagios(reorderedEstagios);
    handleEditarPipilene(reorderedEstagios);
  };

  return (
    <div className={D.pipelineCard}>
      <div className="flex items-center justify-between gap-2 min-w-0">
        <h3 className={D.pipelineCardTitle} title={item.pipeline_nome}>{item.pipeline_nome}</h3>
        <div className="flex items-center gap-1.5 flex-shrink-0">
          <button type="button" className={D.iconButton} aria-label="Editar" onClick={() => onEdit(item)}>
            <Iconify icon="eva:edit-2-outline" width={14} />
          </button>
          <button type="button" className={D.iconButtonDanger} aria-label="Excluir" onClick={() => onDelete(item)}>
            <Iconify icon="eva:trash-2-outline" width={14} />
          </button>
        </div>
      </div>

      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId={`funis-${item._id || item.pipeline_id || index}`}>
          {(provided) => (
            <ul className={D.pipelineStageList} {...provided.droppableProps} ref={provided.innerRef}>
              {isLoading
                ? item?.estagios?.map((_, i) => (
                    <li key={i} className="h-11 rounded-lg bg-[#f4f4f5] animate-pulse" />
                  ))
                : item?.estagios?.map((funil, i) => (
                    <Draggable key={funil._id} draggableId={String(funil._id)} index={i}>
                      {(providedDrag, snapshot) => (
                        <li
                          ref={providedDrag.innerRef}
                          {...providedDrag.draggableProps}
                          {...providedDrag.dragHandleProps}
                          className="min-w-0 w-full"
                        >
                          <PipileneStageItem
                            user={user}
                            cliente={cliente}
                            onEdit={() => {
                              setPipelineId(item._id);
                              setIsEdit(true);
                              setAnchorEl(true);
                            }}
                            onDelete={() => handleDeletePipelineStage(funil._id)}
                            onCallback={onCallback}
                            funil={funil}
                            isDragging={snapshot.isDragging}
                          />
                        </li>
                      )}
                    </Draggable>
                  ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </DragDropContext>

      <button
        type="button"
        className={D.pipelineAddStage}
        aria-describedby={id}
        onClick={(e) => {
          setPipelineId(item._id);
          setIsEdit(false);
          setAnchorEl(e.currentTarget);
        }}
      >
        <Iconify icon="eva:plus-outline" width={14} />
        Adicionar estágio
      </button>

      <PopoverCriarEstagio
        id={id}
        cliente={cliente}
        user={user}
        pipelineId={pipelineId}
        isEdit={isEdit}
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        onCallback={onCallback}
      />
    </div>
  );
}

PipileneItem.propTypes = {
  index: PropTypes.number,
  pipelines: PropTypes.array,
  item: PropTypes.object,
  onCallback: PropTypes.func,
  user: PropTypes.object,
  cliente: PropTypes.object,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};
